import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Observable, of} from 'rxjs';
import {MxConfirmDialogComponent} from '../../mx-dialogs/components/mx-confirm-dialog/mx-confirm-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class MxCloseConfirmationService {

    constructor(private dialog: MatDialog) {
    }

    closeConfirmation(confirmation: boolean = false): Observable<boolean> {
        if (confirmation) {
            return this.dialog.open(MxConfirmDialogComponent,
                {
                    panelClass: 'mx-dialog-panel-class',
                    data: {
                        title: 'Unsaved',
                        message: 'Progress will be lost. Are you sure you want to exit this page?',
                        type: 'warn'
                    }
                })
                .afterClosed();
        }
        return of(true);
    }
}
